import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";
import { XitiMode } from "./../../../src/common/utilities/enums";

let erTag = DefaultAnalyticsConfig.erTag;
if (process.env.ENV === "production") {
  erTag = "2c8cc4be2ef14789b4ef0c9ff64c8ed0";
}

export default class AnalyticsConfig extends DefaultAnalyticsConfig {
  //overwrite configs if needed
  static erTag = erTag;
  static erUserReferenceType = "subscriptionReference";
  //static gtmTag = 'GTM-T7R395H';
  static gtmTag = "GTM-PLD4DJS";
  static xitiPageViewsOnlyTagging = false;
  static xitiScriptUrl = " https://www.letelegramme.fr/js/smarttag.js";
  static XitiStartMode = XitiMode.MINIMAL;
  static xitiPrivacyOptions = ["s2", "ref", "xto", "os", { stc: ["device"] }];
  static cXenseUrl = "https://scdn.cxense.com/cx.js";
  static uatBaseUrl = "http://journal-preprod.letelegramme.fr/data";
  static prodBaseUrl = "http://journal.letelegramme.fr/data";
  static siteId = "1145193685126564430";

  static cmp = {
    hasPreferenceView: true,
    key: "6d222bc8-d7a5-4aca-a39b-5aafecb6101d",
    // Add features that could possibly be behind consent
    features: {
      socialSharing: false,
      ER: true,
      GTM: false,
    },
    ER: {
      vendorId: "c:engagerea-eEYX8TV6",
      purposeId: ["measure_content_performance"],
    },
  };
}



// WEBPACK FOOTER //
// ./clients/tel-tel/js/analyticsConfig.js